// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__miWNG","footerLeft":"Footer_footerLeft__1Qt0n","footerRight":"Footer_footerRight__2XBHw"};